'use client';
import {
  useFormContext,
  useController,
  UseControllerProps
} from 'react-hook-form';

import { BlocksChangeEvent } from '@blocks-web-components/events/blocks-change';
export const useInputController = (props: UseControllerProps) => {
  const { control, setValue } = useFormContext();
  const { field, fieldState, ...rest } = useController({ control, ...props });
  const onBlChange = (e: BlocksChangeEvent): void => {
    setValue(props.name, e.detail.value);
  };
  const isError = !!fieldState.error;
  const fieldNote = fieldState.error?.message;
  return {
    inputField: { ...field, onBlChange, fieldNote, isError },
    field,
    fieldState,
    ...rest
  };
};
